import {
  typedCollection,
  getCollection,
  where,
  orderBy,
} from '@/lib/firebase/firestore'
import type { ClientEngagementDocument } from '@/types'

const engagementsCol = () =>
  typedCollection<ClientEngagementDocument>('clientEngagements')

export const clientEngagementsService = {
  async getEngagementsForUser(
    uid: string
  ): Promise<Array<ClientEngagementDocument & { id: string }>> {
    return getCollection(
      engagementsCol(),
      where('clientUserId', '==', uid),
      where('isArchived', '==', false),
      orderBy('scheduledDate', 'desc')
    )
  },
}
